export const environment = {
  production: true,
  finalRunMode: true,
  assets: "/assets/",
  authorized_url: "https://adminapi.wbcap.in/api/",
  upload_url: "https://adminapi.wbcap.in/api/fileupload",
  unauthorized_url: "https://adminapi.wbcap.in/api/action",
  reportUrl: "https://report.wbcap.in/PrintReport/ShowReport",
  download_url: "https://adminapi.wbcap.in/api/FileDownload?url=",
  meritAllocationBaseUrl: "https://wbcapopen20262.blob.core.windows.net/public/",
  pyServiceUrl: "https://wbadmiservice.applythrunet.co.in",
  botServiceUrl: "https://botapi.wbcap.in",
  botAccessToken: "17e7a685590c4d9797e225a66f06c734",
  DbCode: "CAP_Prod_26",
  encryptionConfig: {
    HMAC_KEY: "JKDHFGUIF7YUIINVhduigfh8747jnv@$%&@*(hjsduighiergh",
    AES_KEY: "98eb956cd9364a88b6a6048439983370",
    ITERATIONS: 1000,
    SECRECTKEY: "7867BHghgdb%^459thrdfjhghfjbnJHGDUDB^$$^^&hjkdughifd",
  },
  firebase_keys: {
    apiKey: "AIzaSyDdafXgyEcKES4gy-M5-YTYtRR4RxbWHNg",
    authDomain: "eskool-admin-web.firebaseapp.com",
    databaseURL: "https://eskool-admin-web.firebaseio.com",
    projectId: "eskool-admin-web",
    storageBucket: "eskool-admin-web.appspot.com",
    messagingSenderId: "253216825841",
    appId: "1:253216825841:web:e6b57ed250ee059b292450",
    measurementId: "G-5K837SG0Y0",
  },
};
